import React, { useState, useRef, useEffect } from 'react';
import { Map, TileLayer, FeatureGroup, GeoJSON } from 'react-leaflet';
import { EditControl } from 'react-leaflet-draw';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import proj4 from 'proj4';
import L from 'leaflet';
import { Form, message, Card } from 'antd';
import axios from 'axios';
import * as reactstrp from 'reactstrap';
import 'leaflet-geometryutil';
import * as serverconfig from '../serverconn'
import { string } from 'prop-types';
var CryptoJS = require("crypto-js");

const FormItem = Form.Item;

// Define Uganda's boundary GeoJSON (Replace with actual boundary data)


const coordinateSystems = [
    { name: 'WGS 84', srid: 4326 },
    { name: 'Web Mercator', srid: 3857 }
];

const ShapeDrawForm = (props) => {
    const [selectedSrid, setSelectedSrid] = useState(4326); // Default SRID
    const [shapes, setShapes] = useState([]);
    const [coordinates, setCoordinates] = useState([]); // State to hold the coordinates
    const mapRef = useRef(); // Create a ref for the map
    const [area, setArea] = useState(0);
    const [length, setLength] = useState(0);
    const [existing_licences, setexisting_licences] = useState([]);


    // Helper function to convert WKT to GeoJSON
    const parseGeometry = (wkt) => {
        // Remove SRID=XXXX; prefix if present
        const wktWithoutSrid = wkt.replace(/SRID=\d+;/, '');
    
        let coordinates = [];
    
        if (wktWithoutSrid.startsWith('POLYGON')) {
            // Handle POLYGON geometry
            coordinates = wktWithoutSrid
                .replace('POLYGON ((', '')
                .replace('))', '')
                .split(', ')
                .map(pair => pair.split(' ').map(Number)); // Convert to number
    
            return {
                type: 'Polygon',
                coordinates: [coordinates] // GeoJSON expects a nested array for polygons
            };
        } else if (wktWithoutSrid.startsWith('LINESTRING')) {
            // Handle LINESTRING geometry (for polylines)
            coordinates = wktWithoutSrid
                .replace('LINESTRING (', '')
                .replace(')', '')
                .split(', ')
                .map(pair => pair.split(' ').map(Number)); // Convert to number
    
            return {
                type: 'LineString',
                coordinates: coordinates // GeoJSON format for LineString
            };
        }
    
        throw new Error('Unsupported WKT geometry type');
    };


    useEffect(() => {

        axios.get(serverconfig.backendserverurl+`/customqueries/get_all_spartial_data`)
        .then(response => {

            //setShapes(response.data);
            console.log('API Response:', JSON.stringify(response.data.data)); // Debugging
            // Ensure data is an array; if it's a FeatureCollection, extract the features array
            const features = response.data.data.features.map(feature => ({
                ...feature,
                geometry: parseGeometry(feature.geometry) // Convert WKT to GeoJSON
            }));
            setexisting_licences(features);


        })
        .catch(error => {
            console.error('Error fetching shapes', error);
        });



        if (mapRef.current) {
            const map = mapRef.current.leafletElement;
            const boundaryLayer = L.geoJSON(props.map_boundary);
            boundaryLayer.addTo(map);
        }
    }, []);


        // Function to bind popups with shape information
        const onEachFeature = (feature, layer) => {
        if (feature.properties) {
            layer.bindPopup(`
                <strong>Description:</strong>Area:  ${feature.properties.calculated_area} Km2 & length: ${feature.properties.length} Km<br />
                <strong>Licence ID :</strong> ${feature.properties.licence_code}<br />
                <strong>Area:</strong> ${feature.properties.calculated_area} Km2 <br />
                <strong>Length:</strong> ${feature.properties.length} meters<br />
            
                <strong>Status:</strong> ${feature.properties.license__status} <br />
                <strong>Grant Date:</strong> ${feature.properties.license__grant_date} <br />
                <strong>Expiry Date:</strong> ${feature.properties.licence_expiry_date} <br />

            
                `);
        }
    };

    const handleSridChange = (event) => {
        setSelectedSrid(parseInt(event.target.value, 10));
    };

    const onCreated = (e) => {
        const { layerType, layer } = e;
        let calLength = 0;
        let calArea = 0;

        /*
        if (!isShapeInsideBoundary(layer)) {
            alert('Shape is outside Uganda boundaries');
        }else{} */

        // Handle polygons for area calculation
        if (layerType === 'polygon') {
            const latlngs = layer.getLatLngs();
            const calculatedArea = L.GeometryUtil.geodesicArea(latlngs[0]); // Area in m²
            const areaInKm2 = (calculatedArea / 1000000).toFixed(2); // Convert m² to km²
            setArea(areaInKm2); // Set area in km²
            setLength(0); // Reset length
            calArea += parseFloat(areaInKm2); // Accumulate total area
        }

        // Handle polylines for length calculation
        if (layerType === 'polyline') {
            const latlngs = layer.getLatLngs();
            const totalLength = L.GeometryUtil.length(latlngs).toFixed(2); // Length in meters
            setLength(totalLength); // Set length
            setArea(0); // Reset area
            calLength += totalLength;
        }

        const geojson = layer.toGeoJSON();

        // Check if shape is within Uganda's boundaries
       // console.log("in Uganda: "+isShapeInsideBoundary(layer))


        const geometryType = geojson.geometry.type;
        let transformedCoordinates;

        switch (geometryType) {
            case 'Point':
                transformedCoordinates = proj4(`EPSG:4326`, `EPSG:${selectedSrid}`, geojson.geometry.coordinates);
                break;
            case 'LineString':
            case 'MultiPoint':
                transformedCoordinates = geojson.geometry.coordinates.map(coord =>
                    proj4(`EPSG:4326`, `EPSG:${selectedSrid}`, coord)
                );
                break;
            case 'Polygon':
            case 'MultiLineString':
                transformedCoordinates = geojson.geometry.coordinates.map(ring =>
                    ring.map(coord => proj4(`EPSG:4326`, `EPSG:${selectedSrid}`, coord))
                );
                break;
            case 'MultiPolygon': // Handle multi-part polygons
                transformedCoordinates = geojson.geometry.coordinates.map(polygon =>
                    polygon.map(ring =>
                        ring.map(coord => proj4(`EPSG:4326`, `EPSG:${selectedSrid}`, coord))
                    )
                );
                break;
            default:
                alert('Unsupported geometry type');
                return;
        }

        // Construct the transformed GeoJSON
        const transformedGeom = {
            ...geojson,
            geometry: {
                ...geojson.geometry,
                coordinates: transformedCoordinates
            }
        };

        //////////////////////////////////
        //validate shape here
        ///////////////////////
        ////////////////////////////
        let form_data = new FormData();
        form_data.append('selected_licence_category', props.selected_licence_category);
        form_data.append('geom', JSON.stringify(transformedGeom.geometry));
        form_data.append('area', calArea);
        form_data.append('selectedSrid', selectedSrid);

        axios.post(serverconfig.backendserverurl+'/customqueries/validate_drawn_shape', form_data, {
            headers: {
                'content-type': 'multipart/form-data'
            }
        })
        .then(res => {

            //log validation message
            message.info(res.data.message);

            if (res.data.message==="Valid"){
                console.log("Its avalid shape")

                const shapeData = {
                    id: shapes.length + 1,
                    name: 'New Shape',
                    geom: transformedGeom.geometry, // Store the transformed geometry
                    srid: selectedSrid
                };
        
                setShapes([...shapes, shapeData]);
        
                // Extract and display coordinates
                setCoordinates(transformedGeom.geometry.coordinates);
        
                //////////////////////////////////
                /////////////////////////////////
                //send data to application form
                props.getSpartialData(e,selectedSrid)
    
            }else{
                message.error("Invalid shape")
            }

        })
        .catch(error => console.log(error));
    
       
    };

    const isShapeInsideBoundary = (shape) => {
        const map = mapRef.current.leafletElement;
        const boundaryLayer = L.geoJSON(props.map_boundary).getLayers()[0];
        return boundaryLayer.getBounds().contains(shape.getBounds().getCenter());
    };


    return (
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%',overflowX:'auto'  }}>
            <Map center={[1.3733, 32.2903]} zoom={7} style={{ height: '500px', width: '70%' ,overflowX:'auto'}} ref={mapRef}>
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution="&copy; OpenStreetMap contributors"
                />
                <FeatureGroup>
                    <EditControl
                        position='topleft'
                        onCreated={onCreated}
                        onEdited={(e) => console.log(e)}
                        onDeleted={(e) => console.log(e)}
                        draw={{
                            rectangle: false,
                            polyline: true,
                            polygon: true,
                            circle: false,
                            marker: false,
                            circlemarker: false,
                        }}
                    />

                    {shapes.map(shape => (
                        <GeoJSON key={shape.id} data={shape.geom} />
                    ))}

                    {/* Add Uganda boundary to the map */}
                    <GeoJSON data={props.map_boundary} />




                    {/**Add existing
                     * 
                     * 
                     * 
                     * 
                     * 
                     *  licences */}

                    {existing_licences.length > 0 && (
                        <GeoJSON
                            data={{ type: 'FeatureCollection', features: existing_licences }}
                            onEachFeature={onEachFeature}
                            
                            style={(feature) => ({
                                fillColor: feature.properties.spartial_shape_background_color || '#3388ff', // Default fill color
                                color: feature.properties.spartial_shape_border_color || '#000000', // Default border color
                                weight: 2, // Border thickness
                                opacity: 1, // Border opacity
                                fillOpacity: 0.7, // Fill opacity
                            })}

                        />
                    )}


                </FeatureGroup>
            </Map>

            <div style={{ height: '500px', width: '30%', marginLeft: 5,overflowX:'auto' }}>
                <Card>
                    <FormItem label="Coordinate System">
                        <select onChange={handleSridChange} value={selectedSrid}>
                            {coordinateSystems.map(({ name, srid }) => (
                                <option key={srid} value={srid}>
                                    {name}
                                </option>
                            ))}
                        </select>
                    </FormItem>

                    {area > 0 && (
                        <div>
                            <h6>Area of drawn shape: {area} Km2</h6>
                        </div>
                    )}

                    {length > 0 && (
                        <div>
                            <h6>Length of drawn shape: {length} meters</h6>
                        </div>
                    )}

                    <h6>Coordinates:</h6>

                    {coordinates.length > 0 ? (
                        <div style={{ display: 'flex', overflowX: 'auto' }}>
                            <reactstrp.Table bordered>
                                <thead>
                                    <tr>
                                        <th>Latitude</th>
                                        <th>Longitude</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {coordinates.flat().map((item, index) => (
                                        <tr key={index}>
                                            <td>{item[1]}</td>
                                            <td>{item[0]}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </reactstrp.Table>
                        </div>
                    ) : (
                        <div>No coordinates available</div>
                    )}
                </Card>
            </div>
        </div>
    );
};

export default ShapeDrawForm;
